import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
  // mounted() {
  //   let obj = document.getElementById('refObjTOS');
  //   if (obj !== undefined && obj !== null) {
  //     obj.onload(() => {
  //       obj.con
  //     });
  //   }
  // }
})

export default class BetterFibreCoZaTOS extends Vue {
}
